import { render, staticRenderFns } from "./Word.vue?vue&type=template&id=6d0970ed&scoped=true&"
import script from "./Word.vue?vue&type=script&lang=js&"
export * from "./Word.vue?vue&type=script&lang=js&"
import style0 from "./Word.vue?vue&type=style&index=0&id=6d0970ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0970ed",
  null
  
)

export default component.exports